export const getRandomColor = () => {
  const colors = ['#b5dbcc', '#fdd483', '#fec89a', '#fcd5ce', '#faedcd', '#fef9ff'];
  const colorPosition = Math.floor(Math.random() * 6);
  return colors[colorPosition];
};
